import { render, staticRenderFns } from "./ColorsForm.vue?vue&type=template&id=5357433c"
import script from "./ColorsForm.vue?vue&type=script&lang=js"
export * from "./ColorsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports